import Axios from './baseApi'

export default {
  async fetch() {
    try {
      const response = await Axios.get('/api/routes/v1');
      return response.data;
    } catch(e) {
      return await Promise.reject(e);
    }
  }
}
